import {
  CATEGORY_ID,
  isKanatiCategory
} from '@/features/TicketCreateDialog/TicketCreateDialog.constants';
import { isValidIP } from '@/pages/Administration/AdministrationEnvironments/AdministrationEnvironments.utils';
import {
  EMPTY_TICKET_TEMPLATE,
  type MessageCreateDTO,
  TICKET_TYPE,
  type Ticket
} from '@/pages/Ticket';
import { parseIpInput } from '@/utils/Common.utils';

const getReferenceTicketTemplate = (ticket: Ticket, data: MessageCreateDTO) => {
  // a reference ticket never inherits a Kanati category; those tickets are created explicitly
  const referencedCategoryId =
    ticket.ticket_type === TICKET_TYPE.SERVICE &&
    !isKanatiCategory(ticket.ticket_category?.id)
      ? ticket.ticket_category?.id
      : CATEGORY_ID.GENERAL_INQUIRY;

  return {
    ...EMPTY_TICKET_TEMPLATE,
    ...(data.attachments && { attachments: data.attachments as [] }),
    category: referencedCategoryId,
    summary:
      `REFERENCE TICKET - ` +
      `https://scope.pondurance.com/ticket/${ticket.id}\n` +
      `- - - - - - - - - - - - - - - - - - - - - -\n${data.body}`,
    title: `REF TICKET - #${ticket.id}:`
  };
};

// filters valid and invalid IP addresses
const filterValidIpAddresses = (
  input: string | string[] | null | undefined
) => {
  const ipAddressesArrayValid: string[] = [];
  const ipAddressesArrayInvalid: string[] = [];
  const stringArray = parseIpInput(input as string);

  stringArray.forEach((item, index) => {
    const [ipAddressStart, ipAddressEnd] = item.includes('-')
      ? item.split('-').map((ip) => ip.trim())
      : [item];

    if (
      !isValidIP(ipAddressStart) ||
      (ipAddressEnd && !isValidIP(ipAddressEnd))
    ) {
      ipAddressesArrayInvalid.push(stringArray[index]);
    } else {
      ipAddressesArrayValid.push(stringArray[index]);
    }
  });

  return { ipAddressesArrayValid, ipAddressesArrayInvalid };
};

// validates the input
const validateIpAddresses = (string: string) => {
  const filteredEnvironments = filterValidIpAddresses(string);
  return filteredEnvironments.ipAddressesArrayInvalid.length === 0;
};

export {
  filterValidIpAddresses,
  getReferenceTicketTemplate,
  validateIpAddresses
};
